module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"headTitle":"Je gegevens","headDescription":"Vul je gegevens aan, zodat we je in contact kunnen brengen met de best geschikte makelaars uit jouw regio.","pill":"De laatste stap voordat je makelaars kunt vergelijken","title":"Vul je gegevens aan","subtext":"Gratis & volledig vrijblijvend","nextBtn":"Vergelijk nu"}}')
  delete Component.options._Ctor
}
